// import CaMinWeightInfobox from './CAMinWeightInfobox.js';
import CaWeightProgress from './CAWeightProgress.js';
// import CAShippingCalculator from './CAShippingCalculator.js';

// if (!customElements.get('ca-min-weight-infobox')) {
//   customElements.define('ca-min-weight-infobox', CaMinWeightInfobox);
// }

if (!customElements.get('ca-weight-progress')) {
  customElements.define('ca-weight-progress', CaWeightProgress);
}

// if (!customElements.get('ca-shipping-calculator')) {
//     customElements.define('ca-shipping-calculator', CAShippingCalculator);
// }